import React from "react";

import { useLocation } from "react-router-dom";

import Portfolio from "../../components/portfolio";

const PortfolioPage = () => {
  const {
    state: { key },
  } = useLocation();
  return <Portfolio data={key} />;
};

export default PortfolioPage;
